/**
 * Statuses whose title is not the editor's to change.
 *
 * The Basic Information title field has been disabled for these since long
 * before the writing tools existed. STY-624 added a second way to set a title,
 * and it did not know about the rule -- so the Title tab could apply a draft
 * to a submission whose title field was greyed out an inch to the left.
 *
 * One exported predicate rather than the expression repeated in two
 * components, so the next status added to the lock reaches both.
 */
export const isTitleLocked = (status) => status === 'quick' || status === 'denied'

export default isTitleLocked
